// The JS mirror of WeightConverter (app/models/weight_converter.rb). The label,
// the display precision and the stepper granularity all have to agree with what
// the server renders, or a blur rounds a value the server sent to one it did not.
// Each function branches the way its Ruby counterpart does, so the two cannot
// disagree on an undefined scale either. LocalizationContextType.weight_scale is
// optional, hence the widened parameter.
type WeightScale = string | undefined

// WeightConverter.unit
export const weightUnit = (scale: WeightScale) => (scale === 'imperial' ? 'oz' : 'g')

// WeightConverter.display_decimals
export const weightDecimals = (scale: WeightScale) => (scale === 'metric' ? 0 : 1)

// WeightConverter.metric_to_imperial
const OUNCES_PER_GRAM = 0.035274

// A step quoted in grams has to be converted, not copied -- 5 g and 5 oz are not
// the same click. Floored at the 0.1 oz the display precision can express.
export const weightStep = (gramStep: number, scale: WeightScale) =>
  scale === 'metric' ? gramStep : Math.max(0.1, parseFloat((gramStep * OUNCES_PER_GRAM).toFixed(1)))
